import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import leadsReducer from './leadsSlice'; // Import the new reducer
import organizationContextReducer from './organizationContextSlice';
import outreachReducer from './outreachSlice';
import productsReducer from './productsSlice';
import connectionsReducer from './connectionsSlice';
import notificationsReducer from './notificationsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    leads: leadsReducer, // Add it to the store
    organizationContext: organizationContextReducer,
    outreach: outreachReducer,
    products: productsReducer,
    connections: connectionsReducer,
    notifications: notificationsReducer,
  },
  // DevTools are enabled by default in development mode
  devTools: process.env.NODE_ENV !== 'production',
});
